<script setup lang="ts">
/**
 * LoginView — `/login` route (Story 013.2 AC7).
 *
 * Minimal, unstyled "Log in with GitLab" entry point — 013.5 owns the
 * Pajamas styling. Text-only per AC10 (no GitLab tanuki logomark).
 */
import { beginLogin } from '../services/oauthLogin';
import { OAUTH_BASE_URL, oauthAuthConfig } from '../oauth.config';

function onLoginClick(): void {
  void beginLogin(
    { baseUrl: OAUTH_BASE_URL, auth: oauthAuthConfig },
    {
      sessionStorage: window.sessionStorage,
      redirect: (url: string) => {
        window.location.href = url;
      },
    },
  );
}
</script>

<template>
  <div class="cwc-login-view">
    <button type="button" data-testid="login-button" @click="onLoginClick">
      Log in with GitLab
    </button>
  </div>
</template>
